import { useEffect } from 'react'
import Header from './components/Header'
import FamilyTree from './components/FamilyTree'
import MigrationTimeline from './components/MigrationTimeline'
import MusicPlayer from './components/MusicPlayer'
import { useFamilyTreeData } from './hooks/useFamilyTreeData'
import './index.css'

function App() {
    const { data, loading, error } = useFamilyTreeData()

    // 预渲染支持：在数据加载完成后触发预渲染事件
    useEffect(() => {
        if (!loading && (data || error)) {
            // 数据加载完成，触发预渲染完成事件
            setTimeout(() => {
                const event = new Event('render-event')
                document.dispatchEvent(event)
                console.log('Data loaded, prerender event dispatched')
            }, 500) // 给组件一些时间来渲染
        }
    }, [loading, data, error])

    return (
        <div className=" text-gray-800 min-h-screen">
            {/* Background overlay */}
            <div id="background-overlay"></div>

            {/* Header */}
            <Header />

            {/* Main content */}
            <main className="container mx-auto px-4 py-8 relative z-10">
                {/* Family Tree Section */}
                <FamilyTree data={data} loading={loading} error={error} />

                {/* Migration Timeline Section */}
                <MigrationTimeline />
            </main>

            {/* Music Player */}
            <MusicPlayer />
        </div>
    )
}

export default App
